import React from 'react';
import { useFormikContext } from 'formik';
import { GenericObject, checkIfSerbianPhoneNumber, checkPhoneNumber } from '@fnol/library/src/lib';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Tooltip, Typography } from '@mui/material';
import { PhoneInputField, YesNoSelector } from '@fnol/library/src/components';
import { constValues, legalPersonType, smsLinkPersonType, translations } from '../../lib/consts';

const SmsLinkSelector = () => {
    const { values, errors, touched, setFieldValue } = useFormikContext<GenericObject>();

    const handleChangeSendLink = (e: { target: { value: any } }): any => {
        setFieldValue('objectSmsLinkType', e.target.value);
        setFieldValue('objectSmsMobile', constValues.dialCodeSerbia);
    };

    const handleChangeSmsLink = () => {
        setFieldValue('objectSmsLinkType', '');
        setFieldValue('objectSmsMobile', constValues.dialCodeSerbia);
    };

    const personsWithDomesticPhoneNumber = [
        {
            id: smsLinkPersonType.thirdParty,
            value: translations.sectionSmsLink.ADD_CONTACT,
            phoneNumber: '',
        },
    ];

    // only individual owner have contact data
    if (
        values.ownerType == legalPersonType.individual &&
        checkIfSerbianPhoneNumber(values.ownerIndividualPhone) &&
        checkPhoneNumber(values.ownerIndividualPhone)
    ) {
        personsWithDomesticPhoneNumber.unshift({
            id: smsLinkPersonType.owner,
            value: `${values.ownerIndividualName} ${values.ownerIndividualLastName}`,
            phoneNumber: values.ownerIndividualPhone,
        });
    }

    // add contact data for submitter
    if (
        values.submitterType == legalPersonType.individual &&
        checkIfSerbianPhoneNumber(values.submitterIndividualPhone) &&
        checkPhoneNumber(values.submitterIndividualPhone)
    ) {
        personsWithDomesticPhoneNumber.unshift({
            id: smsLinkPersonType.submitter,
            value: `${values.submitterIndividualName} ${values.submitterIndividualLastName}`,
            phoneNumber: values.submitterIndividualPhone,
        });
    } else if (
        values.submitterType == legalPersonType.legal &&
        checkIfSerbianPhoneNumber(values.submitterLegalEntityContactPhone) &&
        checkPhoneNumber(values.submitterLegalEntityContactPhone)
    ) {
        personsWithDomesticPhoneNumber.unshift({
            id: smsLinkPersonType.submitterLegal,
            value: values.submitterLegalEntityName,
            phoneNumber: values.submitterLegalEntityContactPhone,
        });
    }

    return (
        <>
            <Typography style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '15px' }} variant="caption">
                {translations.GET_DAMAGE_PHOTO}
            </Typography>

            <Typography variant="subtitle1">{translations.sectionSmsLink.SMS_LINK}</Typography>
            <YesNoSelector
                name="objectHasSmsLink"
                id="objectHasSmsLink"
                onChange={handleChangeSmsLink}
                idTrue="objectHasSmsLinkTrue"
                idFalse="objectHasSmsLinkFalse"
            />
            {values.objectHasSmsLink === 'true' && (
                <>
                    <FormControl>
                        <InputLabel id="send-link-label">
                            {translations.sectionSmsLink.WHO_SHOULD_WE_SEND_LINK}
                        </InputLabel>

                        <Select
                            id="send-link"
                            labelId="send-link-label"
                            name="objectSmsLinkType"
                            value={values.objectSmsLinkType || ''}
                            label={translations.sectionSmsLink.WHO_SHOULD_WE_SEND_LINK}
                            onChange={handleChangeSendLink}
                            error={!!(touched.objectSmsLinkType && errors.objectSmsLinkType)}
                        >
                            {personsWithDomesticPhoneNumber.map((option: any) => {
                                return (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.value}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                        {touched.objectSmsLinkType && errors.objectSmsLinkType ? (
                            <FormHelperText error={true}>
                                <>{errors.objectSmsLinkType}</>
                            </FormHelperText>
                        ) : null}
                    </FormControl>
                </>
            )}
            {values.objectSmsLinkType === smsLinkPersonType.thirdParty && (
                <Tooltip title={<p>{translations.sectionSmsLink.PHONE_TOOLTIP}</p>} placement="top-start">
                    <FormControl>
                        <PhoneInputField
                            name="objectSmsMobile"
                            id="objectSmsMobile"
                            country={'rs'}
                            specialLabel={translations.personalInfo.MOBILE_STAR}
                        />
                    </FormControl>
                </Tooltip>
            )}
        </>
    );
};

export default SmsLinkSelector;
